import util from '../../../util';
import Methods from "../../../api/methods";

const saveImport = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        const headers = util.getAuthHeaderMultipart()
        var data = new FormData();
        data.append('file', payload.file);
        data.append('transfer', payload.transfer);
        data.append('comment', payload.comment);
        data.append('idOrderGeneral', payload.idOrderGeneral);
        data.append('type', payload.type);
        payload.context.axios.post(`imports/${payload.idClient}`, data, { headers }).then((response) => {
            resolve(response.data)
        }).catch(error => {
            if (error.response) {
                util.showDialogError(payload.context, 'Ocurrió un error al importar el archivo.')
                reject(error.response)
            }
            else reject(error)
        });
    })
}

const getFileMaterial = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        const headers = util.getAuthHeader()
        payload.context.axios.get(`/getFileOrder/${payload.idOrderGeneral}`, { headers }).then((response) => {
            resolve(response.data);
        }).catch(error => {
            util.showDialogError(payload.context, 'Ocurrió un error al buscar el archivo.')
            reject(error)
        })
    })
}

const getColumnsImport = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        const headers = util.getAuthHeader()
        payload.context.axios.get(`/imports/${payload.idImport}/columns`, { headers }).then((response) => {
            resolve(response.data)
        }).catch(error => {
            if (error.response) {
                util.showDialogError(payload.context, 'Ocurrió un error al cargar el archivo importado.')
                reject(error.response)
            }
            else reject(error)
        });
    })
}

const processImport = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        const headers = util.getAuthHeader()
        payload.context.axios.post(`imports/process/${payload.idClient}/${payload.idImport}/${payload.idCategory}`, payload.fieldsImport, { headers }).then((response) => {
            resolve(response.data)
        }).catch(error => {
            if (error.response) {
                util.showDialogError(payload.context, error.response.data.message)
                reject(error.response)
            }
            else reject(error)
        });
    })
}

const confirmImport = (context, payload) => {
    const url = `imports/checkin/${payload.idClient}/${payload.idImport}`
    return Methods.doPost(context, url, {}, null)
}

export default {
    saveImport,
    getFileMaterial,
    getColumnsImport,
    processImport,
    confirmImport
};




// WEBPACK FOOTER //
// ./src/store/modules/imports/action.js